<template>
  <div>
    <v-card tile>
      <v-card-title>
        <h3>Feedback</h3>
        <v-spacer></v-spacer>
        <v-btn @click="downloadFeedback" :loading="loading.pdf" :disabled="pdfBtnDisabled || loading.pdf" outline color="blue">PDF
          <v-icon>list</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>

      <v-container>
        <v-layout row wrap>

          <v-flex xs12 sm4 md2>
            <v-menu v-model="menuDateStart">
              <v-text-field
                v-model="feedbackForm.dateStart"
                slot="activator"
                label="Visitation date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="feedbackForm.dateStart" reactive></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm4 md2 offset-sm1>
            <v-text-field
              label="Visitation time"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="feedbackForm.timeStart"
              type="time"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-combobox
              :items="caseManagers"
              v-model="feedbackForm.selectedUser"
              label="Briefing by"
            ></v-combobox>
          </v-flex>

          <v-flex xs12 sm4 md2>
            <v-text-field
              label="Family assemble time"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="feedbackForm.familyAssembleTime"
              type="time"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md2 offset-sm1>
            <v-text-field
              label="Funeral Time"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="feedbackForm.funeralServiceCommencedTime"
              type="time"
            ></v-text-field>
          </v-flex>


          <v-flex xs12>
            <v-combobox
              :items="['lifting of coffin', 'fong ting', 'sa jing']"
              multiple
              small-chips
              v-model="feedbackForm.funeralRites"
              label="Funeral rites"
            ></v-combobox>
          </v-flex>

          <v-flex xs12 sm4 md2>
            <v-text-field
              label="Cortege leave time"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="feedbackForm.cortegeLeaveTime"
              type="time"
            ></v-text-field>
          </v-flex>
          <v-flex sm8 md10></v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="feedbackForm.churchLocation"
              label="Church location"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 offset-sm1>
            <v-text-field
              label="Church mass at"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="feedbackForm.churchMassAt"
              type="time"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              v-model="feedbackForm.drivingPass"
              label="Driving pass"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-select
              :items="['Mandai Crematorium', 'Kong Meng San Phor Kark See Monastery', 'Tse Tho Aum Temple', 'Choa Chu Kang Cemetery Complex']"
              v-model="feedbackForm.cremationLocation"
              label="Cremation location"
            />
          </v-flex>
          <v-flex xs12 sm2 offset-sm1>
            <v-text-field
              label="Cremation time"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="feedbackForm.cremationTime"
              type="time"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              v-model="feedbackForm.postFuneralSendTo"
              label="Post funeral send to"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="feedbackForm.ashCollection"
              label="Ash collection"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 md2 offset-sm0 offset-md1>
            <v-menu v-model="menuAshCollectionDate">
              <v-text-field
                v-model="feedbackForm.ashCollectionDate"
                slot="activator"
                label="Ash collection date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="feedbackForm.ashCollectionDate" reactive></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 md2 offset-sm0 offset-md1>
            <v-text-field
              label="Ash collection time"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="feedbackForm.ashCollectionTime"
              type="time"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="feedbackForm.sendAshTo"
              label="Send ash to"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 md2 offset-sm0 offset-md1>
            <v-menu v-model="menuSendAshToDate">
              <v-text-field
                v-model="feedbackForm.sendAshToDate"
                slot="activator"
                label="Send ash to date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="feedbackForm.sendAshToDate" reactive></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 md2 offset-sm0 offset-md1>
            <v-text-field
              label="Send ash to time"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="feedbackForm.sendAshToTime"
              type="time"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="feedbackForm.seaBurialAt"
              label="Sea burial at"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 md2 offset-sm0 offset-md1>
            <v-menu v-model="menuSeaBurialAtDate">
              <v-text-field
                v-model="feedbackForm.seaBurialAtDate"
                slot="activator"
                label="Sea burial at date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="feedbackForm.seaBurialAtDate" reactive></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 md2 offset-sm0 offset-md1>
            <v-text-field
              label="Sea burial at time"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="feedbackForm.seaBurialAtTime"
              type="time"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm4 md2>
            <v-text-field
              label="Tear down of Tentage will be after"
              prepend-icon="alarm"
              value="12:30:00"
              v-model="feedbackForm.tentageAfter"
              type="time"
            ></v-text-field>
          </v-flex>
          <v-flex sm8 md10></v-flex>

          <v-flex xs12>
            <v-label gray>Satisfied with set up?</v-label>
          </v-flex>
          <v-flex xs12 sm3 md2>
            <v-radio-group v-model="feedbackForm.satisfiedWithSetUp" row>
              <v-radio
                label="Yes"
                :value="true"
              ></v-radio>
              <v-radio
                label="No"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 sm9 offset-sm0 offset-md1>
            <v-text-field
              v-model="feedbackForm.satisfiedWithSetUpWhy"
              label="Why?"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-label gray>Satisfied with catering?</v-label>
          </v-flex>
          <v-flex xs12 sm3 md2>
            <v-radio-group v-model="feedbackForm.satisfiedWithCatering" row>
              <v-radio
                label="Yes"
                :value="true"
              ></v-radio>
              <v-radio
                label="No"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 sm9 offset-sm0 offset-md1>
            <v-text-field
              v-model="feedbackForm.satisfiedWithCateringWhy"
              label="Why?"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-label gray>Satisfied with night service?</v-label>
          </v-flex>
          <v-flex xs12 sm3 md2>
            <v-radio-group v-model="feedbackForm.satisfiedWithNightService" row>
              <v-radio
                label="Yes"
                :value="true"
              ></v-radio>
              <v-radio
                label="No"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 sm9 offset-sm0 offset-md1>
            <v-text-field
              v-model="feedbackForm.satisfiedWithNightServiceWhy"
              label="Why?"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-label gray>Satisfied with information provided?</v-label>
          </v-flex>
          <v-flex xs12 sm3 md2>
            <v-radio-group v-model="feedbackForm.satisfiedWithInformationProvided" row>
              <v-radio
                label="Yes"
                :value="true"
              ></v-radio>
              <v-radio
                label="No"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 sm9 offset-sm0 offset-md1>
            <v-text-field
              v-model="feedbackForm.satisfiedWithInformationProvidedWhy"
              label="Why?"
            ></v-text-field>
          </v-flex>

        </v-layout>
      </v-container>

      <v-divider></v-divider>

      <v-card-title>
        <h3>Client Agreement Sign</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-tooltip top>
          <v-btn slot="activator" flat icon @click="clearSignature">
            <v-icon color="red">undo</v-icon>
          </v-btn>
          Clear signature
        </v-tooltip>

        <div class="sign-pad" id="signature-pad">
          <VueSignaturePad
            height="250px"
            width="500px"
            ref="signaturePad"
          />
        </div>

      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          block
          @click="saveFeedback"
          :loading="loading.signBtn"
          :disabled="loading.signBtn">
          Save feedback
        </v-btn>
        <v-snackbar
          v-model="snackbar"
          bottom
          color="success"
          multi-line
          :timeout="2000"
        >Feedback saved!</v-snackbar>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import ServicesDataTable from '@/components/datatables/ServicesDataTable'
  import { mapGetters } from 'vuex'

  export default {
    components: {ServicesDataTable},
    props: {
      caseModel: {
        type: Object,
        required: true
      },
      selectedTab1: {}
    },
    computed: {
      ...mapGetters({
        clientById: 'getClientById',
        caseInvoices: 'currentCaseInvoices',
        allUsers: 'allUsers',
        allUsersFull: 'allUsersFull',
        storeFeedbackForm: 'getFeedbackClientForm'
      }),
      dateStartString () {
        return this.dateStart + ' ' + (this.timeStart === null ? '00:00:00' : this.timeStart)
      },
      caseManagers () {
        return this.allUsersFull.filter(i => i.roles.map(i => i.name).includes('case-manager'))
      }
    },
    data () {
      return {
        pdfBtnDisabled: true,

        feedbackForm: {},

        menuDateStart: false,
        menuAshCollectionDate: false,
        menuSendAshToDate: false,
        menuSeaBurialAtDate: false,

        snackbar: false,

        loading: {
          pdf: false,
          feedback: false,
          signBtn: false
        }
      }
    },
    watch: {
      timeStart (newVal) {
        if (newVal.indexOf(':') !== -1) {
          this.menuTimeStart.state = false
        }
      },
      selectedTab1 (val) {
        if (val === 'agreement-feedback-tab') {
          setTimeout(() => {
            this.resizeCanvas()
          }, 2000)
        }
      }
    },
    methods: {
      downloadFeedback () {
        this.loading.pdf = true
        this.$store.dispatch('loadPdfFeedback', this.storeFeedbackForm.id).then(result => {
          this.loading.pdf = false
          window.open(window.location.origin === 'http://localhost:8080' ? window.location.origin + '/' + result.aws_s3_url : result.aws_s3_url, '_blank')
        })
      },
      clearSignature () {
        this.$refs.signaturePad.undoSignature()
      },
      onServicesChanged (services) {
        this.feedbackForm.addOnServices = services
      },
      saveFeedback () {
        this.loading.signBtn = true

        let signature = this.$refs.signaturePad.saveSignature()
        if (!signature.isEmpty) {
          this.feedbackForm.client_signature = signature.data
        }

        this.$store.commit('updateFeedbackForm', this.feedbackForm)
        this.$store.dispatch('storeFeedbackForm').then((result) => {
          this.pdfBtnDisabled = false
          this.snackbar = true
          this.loading.signBtn = false
          location.reload()
        })
      },
      resizeCanvas () {
        let ratio = Math.max(window.devicePixelRatio || 1, 1)
        let wrapper = window.document.getElementById('signature-pad')
        let canvas = wrapper.getElementsByTagName('canvas')[0]

        canvas.width = canvas.offsetWidth * ratio
        canvas.height = canvas.offsetHeight * ratio
        canvas.getContext('2d').scale(ratio, ratio)
        // this.$refs.signaturePad.clear()
      }
    },
    mounted () {
      this.$nextTick(function () {
        setTimeout(() => {
          window.onresize = this.resizeCanvas
          this.resizeCanvas()
        }, 2000)
      })
    },
    created () {
      if (this.storeFeedbackForm.id !== null) this.pdfBtnDisabled = false
      this.feedbackForm = this.storeFeedbackForm.answer
    }
  }
</script>

<style scoped>
  .sign-pad div {
    max-width: 100%;
    border: 1px solid #949494;
  }
</style>



// WEBPACK FOOTER //
// CaseAgreementFeedback.vue?60095dc2